'use strict';

function isValidValue($el) {
    return $el.val() && $el.val() !== 0 && $el.val()  !== '0';
}

export var fnCustomApprove = function () {
    const requiredWith = {
        expects:[
            'sibling1',
            'sibling2'
        ],
        message: '',
        validate: function(value,pars){
            const result = {
                valid: true,
                errors: []
            };

            const sibling1Val = $(pars.sibling1);
            const sibling2Val = $(pars.sibling2);
            if(isValidValue(sibling1Val) || isValidValue(sibling2Val)){
                result.valid = !!value;
            }
            return result;
        }
    };
    approve.addTest(requiredWith, 'requiredWith');
};